import {
  Autocomplete,
  TextField,
  InputAdornment,
  useMediaQuery,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import styles from "./styles.module.css";
import { useEffect, useState } from "react";
import { buscarComboPorCodigo } from "../../../services/auth.service";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import GridViewIcon from "@mui/icons-material/GridView";

const Header = ({
  header,
  handleGrupoEmpresa,
  hasEmpresa,
  debounce,
  uniqueEmpresa,
  selectedAllEmpresas,
  complementaryHeaderTop,
  complementaryHeaderBottom,
  view,
  handleChangeView,
  searchPlaceholder,
}) => {
  const maxCelular = useMediaQuery("(max-width: 470px)");
  const [search, setSearch] = useState("");
  const [optionsGrupoEmpresas, setOptionsGrupoEmpresas] = useState({
    GE: [],
    CNPJ: [],
  });
  const [grupoEmpresas, setGrupoEmpresas] = useState({
    GE: null,
    CNPJ: uniqueEmpresa ? null : [],
  });

  const styleAutoComplete = {
    width: maxCelular ? "100%" : "",
    maxWidth: "20rem",
    minWidth: maxCelular ? "" : "250px",
    "& .MuiOutlinedInput-root": {
      borderRadius: "50px",
      "& fieldset": {
        borderColor: "#18316e",
      },
      "&:hover fieldset": {
        borderColor: "#18316e",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#18316e",
        maxHeight: "5rem",
        overflow: "scroll",
      },
    },
  };

  const handleChangeGECNPJ = (name, value) => {
    switch (name) {
      case "GE":
        if (value) {
          setGrupoEmpresas({ ...grupoEmpresas, GE: value });
        } else {
          setGrupoEmpresas({ GE: null, CNPJ: uniqueEmpresa ? null : [] });
          setOptionsGrupoEmpresas({ ...optionsGrupoEmpresas, CNPJ: [] });
        }
        break;
      case "CNPJ":
        if (value) {
          setGrupoEmpresas({ ...grupoEmpresas, CNPJ: value });
        } else {
          setGrupoEmpresas({
            ...grupoEmpresas,
            CNPJ: uniqueEmpresa ? null : [],
          });
        }
        break;

      default:
        break;
    }
  };

  const handleCombos = async (codCombo) => {
    const response = await buscarComboPorCodigo(codCombo);
    const combosFormat = response.detalhes.itensCombo
      .filter((item) => item)
      .map((item) => {
        const split = item.split("/|/");
        return {
          id: split[0],
          detalhes: split[1],
        };
      });

    const uniqueCombos = combosFormat.filter(
      (combo, index, self) =>
        index === self.findIndex((t) => t.detalhes === combo.detalhes)
    );

    return uniqueCombos;
  };

  useEffect(() => {
    const fetchGrupos = async () => {
      const grupos = await handleCombos("GRUPOECONOMICO");
      setOptionsGrupoEmpresas({ ...optionsGrupoEmpresas, GE: grupos });
    };

    handleGrupoEmpresa && fetchGrupos();
  }, []);

  useEffect(() => {
    handleGrupoEmpresa && handleGrupoEmpresa(grupoEmpresas);
  }, [grupoEmpresas]);

  useEffect(() => {
    const fetchEmpresas = async () => {
      const empresas = await handleCombos(
        `EMPRESA_POR_GRUPO_TABLECARD_${grupoEmpresas.GE?.id}`
      );
      const empresasMask = empresas.map((item) => {
        return {
          ...item,
          detalhes: item.detalhes.replace(
            /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
            "$1.$2.$3/$4-$5"
          ),
        };
      });
      setOptionsGrupoEmpresas({ ...optionsGrupoEmpresas, CNPJ: empresasMask });
      selectedAllEmpresas &&
        setGrupoEmpresas({ ...grupoEmpresas, CNPJ: empresas });
    };
    if (hasEmpresa && grupoEmpresas.GE) fetchEmpresas();
  }, [grupoEmpresas.GE]);
  return (
    <div>
      <div className={styles.headerContainer}>
        {header ? (
          <div className={styles.header}>
            <div className={styles.headerIcon}>{header.icon}</div>
            <div className={styles.headerTitle}>{header.title}</div>
          </div>
        ) : (
          <div />
        )}
        <div className={styles.headerRight}>
          {handleGrupoEmpresa && (
            <div className={styles.headerEmpresas}>
              <Autocomplete
                value={grupoEmpresas.GE}
                sx={styleAutoComplete}
                id="tags-outlined"
                isOptionEqualToValue={(option, value) => option.id === value.id}
                options={optionsGrupoEmpresas.GE || []}
                getOptionLabel={(option) => option.detalhes}
                onChange={(_, value) => handleChangeGECNPJ("GE", value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    variant="outlined"
                    label="Grupo Economico"
                  />
                )}
              />

              {hasEmpresa && (
                <Autocomplete
                  value={grupoEmpresas.CNPJ}
                  sx={styleAutoComplete}
                  disableCloseOnSelect={uniqueEmpresa ? false : true}
                  multiple={uniqueEmpresa ? false : true}
                  limitTags={1}
                  id="tags-outlined"
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  noOptionsText="Nenhuma empresa encontrada."
                  options={optionsGrupoEmpresas.CNPJ}
                  getOptionLabel={(option) => option.detalhes}
                  onChange={(_, value) => handleChangeGECNPJ("CNPJ", value)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      variant="outlined"
                      label="Empresas"
                    />
                  )}
                />
              )}
            </div>
          )}
          {complementaryHeaderTop && complementaryHeaderTop}
          {complementaryHeaderBottom && complementaryHeaderBottom}
          {debounce && (
            <div className={styles.debounce}>
              <TextField
                sx={styleAutoComplete}
                label={searchPlaceholder || "Busca por CNPJ"}
                id="outlined-start-adornment"
                onChange={(e) => {
                  debounce(e.target.value);
                  setSearch(e.target.value);
                }}
                value={search}
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: "#18316e" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          )}
          <div className={styles.selectView}>
            <FormatListBulletedIcon
              className={
                view === "table" ? styles.iconViewActive : styles.iconView
              }
              onClick={() => handleChangeView("table")}
            />
            <GridViewIcon
              className={
                view === "grid" ? styles.iconViewActive : styles.iconView
              }
              onClick={() => handleChangeView("grid")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
